import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../shared/theme';

const Container = styled.div`
  width: 154px;
  height: 45px;
  padding: 12px 16px;
  border-radius: 6px;
  background: rgba(193, 157, 63, 0.78);
  box-shadow: 0px 12px 12px rgba(50, 50, 71, 0.08), 0px 16px 24px rgba(50, 50, 71, 0.08);
  backdrop-filter: blur(4px);
  position: fixed;
  bottom: ${props => (dt(props).theme.isMobileOrTablet ? 32 : 48) + props.yOffset}px;
  right: ${props => (dt(props).theme.isMobileOrTablet ? 20 : 48)}px;
`;

const HFlex = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;

  & > .icon-lw-preview {
    :before {
      color: ${props => dt(props).theme.bodyBackgroundColor};
    }
    font-size: 20px;
    margin-left: 8px;
  }
`;

const Text = styled.span`
  font: ${props => dt(props).theme.fontWeightHeavy} 17px/20px ${props => dt(props).theme.fontFamilyBody};
  color: ${props => dt(props).theme.bodyBackgroundColor};
`;

export default function PreviewMode({ yOffset }) {
  return (
    <Container yOffset={yOffset}>
      <HFlex>
        <Text>Preview Mode</Text>
        <span className="icon-lw icon-lw-preview" />
      </HFlex>
    </Container>
  );
}

PreviewMode.propTypes = {
  yOffset: PropTypes.number,
};

PreviewMode.defaultProps = {
  yOffset: 0,
};
